import { Link } from '@remix-run/react'
import { AuthorAvatar } from '../AuthorAvatar'

import { generatePath } from 'react-router'
import { routes } from '~/queries/routes'
import { Asset, Entry } from 'contentful'
import { TypeAuthorSkeleton } from '~/types/contentful'

type AuthorCardProps = {
  author: Entry<TypeAuthorSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const AuthorCard = ({ author }: AuthorCardProps) => {
  const { avatar, name, bio, slug } = author.fields

  return (
    <div className="p-6 flex md:flex-col bg-neutral-5 rounded-3xl">
      {avatar && (
        <AuthorAvatar asset={avatar as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>} size="XL" />
      )}
      <Link className="max-lg:mb-2" to={generatePath(routes.author, { slug })}>
        <p className="text-m mb-2 xl:mb-4">{name}</p>
        <p className="text-s text-neutral-60">{bio}</p>
      </Link>
    </div>
  )
}
